"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userDirectoryPageSchema = exports.userDirectoryRecordSchema = exports.accessPolicySummarySchema = exports.userProfileSummarySchema = exports.organizationUnitSchema = exports.organizationDirectoryEntrySchema = exports.tenantDirectoryEntrySchema = void 0;
const zod_1 = require("zod");
exports.tenantDirectoryEntrySchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    slug: zod_1.z.string(),
    status: zod_1.z.string().optional(),
    plan: zod_1.z.string().optional(),
    createdAt: zod_1.z.string().optional(),
});
exports.organizationDirectoryEntrySchema = zod_1.z.object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    name: zod_1.z.string(),
    type: zod_1.z.string().optional(),
    industry: zod_1.z.string().optional(),
    status: zod_1.z.string().optional(),
});
exports.organizationUnitSchema = zod_1.z.object({
    id: zod_1.z.string(),
    organizationId: zod_1.z.string(),
    name: zod_1.z.string(),
    code: zod_1.z.string().optional(),
    description: zod_1.z.string().optional(),
    parentId: zod_1.z.string().nullable().optional(),
    headcount: zod_1.z.number().int().nonnegative().optional(),
});
exports.userProfileSummarySchema = zod_1.z.object({
    id: zod_1.z.string(),
    userId: zod_1.z.string(),
    tenantId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    firstName: zod_1.z.string().optional(),
    lastName: zod_1.z.string().optional(),
    email: zod_1.z.string().optional(),
    status: zod_1.z.string().optional(),
    persona: zod_1.z.string().optional(),
    title: zod_1.z.string().optional(),
    department: zod_1.z.string().optional(),
    employmentType: zod_1.z.string().optional(),
    organizationUnits: zod_1.z.array(zod_1.z.object({ id: zod_1.z.string(), name: zod_1.z.string().optional() })).default([]),
    lastSignInAt: zod_1.z.string().optional(),
    createdAt: zod_1.z.string().optional(),
});
exports.accessPolicySummarySchema = zod_1.z.object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    scope: zod_1.z.string(),
    scopeId: zod_1.z.string().optional(),
    name: zod_1.z.string(),
    description: zod_1.z.string().optional(),
    effect: zod_1.z.enum(["allow", "deny"]).optional(),
    createdAt: zod_1.z.string().optional(),
    updatedAt: zod_1.z.string().optional(),
});
exports.userDirectoryRecordSchema = zod_1.z.object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string().optional(), // Backend may omit when user has no org membership
    organizationId: zod_1.z.string().nullable().optional(),
    email: zod_1.z.string(),
    phone: zod_1.z.string().nullable().optional(),
    status: zod_1.z.string().optional(),
    firstName: zod_1.z.string().nullable().optional(),
    lastName: zod_1.z.string().nullable().optional(),
    persona: zod_1.z.string().nullable().optional(),
    locale: zod_1.z.string().optional(),
    timeZone: zod_1.z.string().optional(),
    lastSignInAt: zod_1.z.string().nullable().optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.userDirectoryPageSchema = zod_1.z.object({
    data: zod_1.z.array(exports.userDirectoryRecordSchema),
    nextCursor: zod_1.z.string().optional(),
    total: zod_1.z.number().int().nonnegative().optional(),
});
